// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__82GdI","container":"Footer_container__9I44I"};